import { Button, Modal } from 'react-bootstrap';

import AppButton from '../buttons/AppButton';
import { useNavigate } from 'react-router-dom';

export function ContractInactiveModal({ show, onHide }) {
  const navigate = useNavigate();

  const handleRedirect = () => {
    onHide();
    navigate('assinatura');
  };

  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Contrato Inativo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Seu contrato está inativo. Por favor, regularize sua situação para continuar utilizando o sistema.
      </Modal.Body>
      <Modal.Footer>
        <AppButton name='Regularizar agora' onClick={handleRedirect}/>
      </Modal.Footer>
    </Modal>
  );
}